// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--1uJje","content":"content--3o3LF contentWrapper--AHarZ","title":"title--Lu-ui title--3f9JQ","detail":"detail--D3Q41 contentArea--SiMDT"};


//////////////////
// WEBPACK FOOTER
// ./screens/NewsOverview/styles.css
// module id = 1069
// module chunks = 2